import jsPDF from "jspdf";

/**
 * Génère un PDF propre et imprimable de la fiche véhicule, utilisable pour
 * l'envoyer à un garagiste.
 */
export function exportVehiclePdf(vehicle) {
  if (!vehicle) return;

  const doc = new jsPDF({ unit: "pt", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 48;
  let y = 0;

  // --- En-tête ---
  doc.setFillColor(11, 17, 32); // slate-950
  doc.rect(0, 0, pageWidth, 90, "F");
  doc.setFillColor(6, 182, 212); // cyan-500
  doc.rect(0, 90, pageWidth, 4, "F");

  doc.setFont("helvetica", "bold");
  doc.setFontSize(22);
  doc.setTextColor(255, 255, 255);
  doc.text("Autopièce Malin", margin, 46);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(165, 243, 252); // cyan-200
  doc.text("Fiche véhicule — à transmettre à votre garagiste", margin, 68);

  // Plaque à droite
  const plate = vehicle.plaque || "";
  if (plate) {
    const w = 120;
    const h = 32;
    const x = pageWidth - margin - w;
    const py = 30;
    doc.setFillColor(253, 224, 71); // jaune plaque
    doc.roundedRect(x, py, w, h, 4, 4, "F");
    doc.setFont("courier", "bold");
    doc.setFontSize(16);
    doc.setTextColor(15, 23, 42);
    doc.text(plate, x + w / 2, py + 22, { align: "center" });
  }

  y = 130;

  // --- Titre véhicule ---
  doc.setFont("helvetica", "bold");
  doc.setFontSize(20);
  doc.setTextColor(15, 23, 42);
  doc.text(`${vehicle.marque || ""} ${vehicle.modele || ""}`.trim(), margin, y);

  y += 20;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(100, 116, 139);
  if (vehicle.finition) doc.text(vehicle.finition, margin, y);

  y += 30;

  // --- Spécifications techniques ---
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.setTextColor(6, 182, 212);
  doc.text("CARACTÉRISTIQUES TECHNIQUES", margin, y);
  y += 6;
  doc.setDrawColor(226, 232, 240);
  doc.line(margin, y, pageWidth - margin, y);
  y += 18;

  const specs = [
    ["Année", vehicle.annee],
    ["Code moteur", vehicle.code_moteur],
    ["Cylindrée", vehicle.cylindree],
    [
      "Puissance",
      vehicle.puissance_kw && vehicle.puissance_ch
        ? `${vehicle.puissance_kw} kW · ${vehicle.puissance_ch} ch`
        : vehicle.puissance_ch
          ? `${vehicle.puissance_ch} ch`
          : null,
    ],
    ["Puissance fiscale", vehicle.puissance_fiscale ? `${vehicle.puissance_fiscale} CV` : null],
    ["Carburant", vehicle.carburant],
    ["Boîte", vehicle.boite || vehicle.type_boite],
    ["Carrosserie", vehicle.type_carrosserie],
    ["Nombre de portes", vehicle.nombre_portes ? `${vehicle.nombre_portes} portes` : null],
    ["Code mine", vehicle.code_mine],
    ["VIN partiel", vehicle.vin_partiel],
    ["Couleur", vehicle.couleur],
  ].filter(([, v]) => v !== undefined && v !== null && v !== "");

  const colWidth = (pageWidth - margin * 2) / 2;
  const rowHeight = 44;
  specs.forEach((spec, idx) => {
    const col = idx % 2;
    const row = Math.floor(idx / 2);
    const x = margin + col * colWidth;
    const cellY = y + row * rowHeight;

    doc.setDrawColor(226, 232, 240);
    doc.setFillColor(248, 250, 252);
    doc.roundedRect(x, cellY, colWidth - 10, rowHeight - 8, 6, 6, "FD");

    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor(100, 116, 139);
    doc.text(spec[0].toUpperCase(), x + 12, cellY + 14);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.setTextColor(15, 23, 42);
    doc.text(String(spec[1]), x + 12, cellY + 30);
  });

  y += Math.ceil(specs.length / 2) * rowHeight + 20;

  // --- Encart garagiste ---
  if (y > 680) {
    doc.addPage();
    y = margin;
  }
  doc.setFillColor(6, 182, 212, 0.08);
  doc.setFillColor(240, 253, 255);
  doc.roundedRect(margin, y, pageWidth - margin * 2, 90, 8, 8, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.setTextColor(14, 116, 144);
  doc.text("Pour votre garagiste", margin + 14, y + 20);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.setTextColor(51, 65, 85);
  const notes = [
    "Cette fiche identifie précisément mon véhicule.",
    "Merci de vérifier la compatibilité des pièces à partir du code moteur et du code mine.",
    "En cas de doute sur une référence OEM, je peux vous transmettre le VIN complet.",
  ];
  notes.forEach((n, i) => doc.text("• " + n, margin + 14, y + 38 + i * 14));

  y += 110;

  // --- Pied de page ---
  const generatedAt = new Date().toLocaleString("fr-FR");
  doc.setFont("helvetica", "italic");
  doc.setFontSize(8);
  doc.setTextColor(148, 163, 184);
  doc.text(
    `Fiche générée le ${generatedAt} par Autopièce Malin (autopiecemalin.fr) — comparateur indépendant.`,
    margin,
    y,
  );

  const filename = `fiche-vehicule-${(plate || "autopiecemalin").toLowerCase().replace(/[^a-z0-9]/g, "")}.pdf`;
  doc.save(filename);
}
